import React from "react";
import { formatPrice, t } from "../i18n";

export default function PlayButton({ userHasAccess, onPlay, onBuy, onSubscribe, disabled, isBuying, purchasesEnabled = true, price }) {
  const handle = (fn) => () => {
    if (typeof fn === "function") fn();
  };
  const formattedPrice = formatPrice(price);

  if (userHasAccess) {
    return (
      <button
        type="button"
        className="rounded-full bg-pink-500 px-6 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-white transition hover:bg-pink-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-pink-300 disabled:opacity-60"
        onClick={handle(onPlay)}
        disabled={disabled}
      >
        {t("Play")}
      </button>
    );
  }

  return (
    <div className="flex flex-wrap gap-3">
      <button
        type="button"
        className="rounded-full bg-sky-300 px-6 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-slate-950 shadow-lg shadow-sky-950/20 transition hover:bg-cyan-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-200 disabled:opacity-60"
        onClick={handle(onSubscribe)}
        disabled={disabled}
      >
        {t("Subscribe")}
      </button>
      <button
        type="button"
        className="rounded-full bg-emerald-500 px-6 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-white transition hover:bg-emerald-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 disabled:opacity-60"
        onClick={handle(onBuy)}
        disabled={disabled || isBuying || !purchasesEnabled}
      >
        {!purchasesEnabled
          ? t("Admin activation")
          : isBuying
            ? t("Opening...")
            : formattedPrice
              ? t("Buy ({{price}})", { price: formattedPrice })
              : t("Buy")}
      </button>
    </div>
  );
}
